import type { UniversalBusinessContext } from './types';

export const DEFAULT_CONTEXT: UniversalBusinessContext = {
  sellerId: null,
  sellerLabel: '—',
  connectionId: null,
  marketplace: 'Amazon',
  dateRange: '7d',
  comparePeriod: 'previous_period',
  businessUnit: null,
  warehouseId: null,
  state: null,
  city: null,
  category: null,
  subCategory: null,
  brand: null,
  asin: null,
  sku: null,
  fnsku: null,
  productType: null,
  orderStatus: null,
  inventoryStatus: null,
  pricingStatus: null,
  returnStatus: null,
  hour: null,
  day: null,
  week: null,
  month: null,
  quarter: null,
  year: null,
  timeGrain: null,
  search: '',
  lastWorkspacePath: null,
};

export const DATE_RANGE_OPTIONS: { value: UniversalBusinessContext['dateRange']; label: string }[] =
  [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: '7d', label: 'Last 7 days' },
    { value: '30d', label: 'Last 30 days' },
    { value: 'mtd', label: 'Month to date' },
    { value: 'qtd', label: 'Quarter to date' },
    { value: 'ytd', label: 'Year to date' },
    { value: 'custom', label: 'Custom' },
  ];

export const COMPARE_OPTIONS: { value: UniversalBusinessContext['comparePeriod']; label: string }[] =
  [
    { value: 'none', label: 'No compare' },
    { value: 'previous_period', label: 'Previous period' },
    { value: 'previous_year', label: 'Previous year' },
    { value: 'custom', label: 'Custom' },
  ];
